module.exports = __webpack_public_path__ + "assets/img/BrightTideLogo.3b19e10d.png";